import {
  type SourceKey,
  SOURCE_KEYS,
  SOURCE_LABELS,
  SOURCE_ICONS,
} from "../../lib/revenuePlannerEngine";

// =============================================================================
// SourceToggle — ON/OFF Chips for Traffic Sources
// =============================================================================

interface SourceToggleProps {
  activeSources: SourceKey[];
  onToggle: (key: SourceKey) => void;
  disabled?: boolean;
}

const SOURCE_COLORS: Record<SourceKey, string> = {
  webinar: "var(--funnel-webinar, #6366f1)",
  typeform: "var(--funnel-typeform, #f59e0b)",
  dm: "var(--funnel-colddm, #10b981)",
};

export default function SourceToggle({ activeSources, onToggle, disabled }: SourceToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <span
        className="font-medium uppercase tracking-wide"
        style={{ fontSize: 10, color: "var(--text-tertiary)", letterSpacing: "0.06em" }}
      >
        Sources
      </span>
      {SOURCE_KEYS.map((key) => {
        const isActive = activeSources.includes(key);
        const color = SOURCE_COLORS[key];
        return (
          <button
            key={key}
            onClick={() => onToggle(key)}
            disabled={disabled}
            className="anim-tap flex items-center gap-1.5 rounded-full font-medium transition-all"
            style={{
              fontSize: 11,
              padding: "4px 12px",
              color: isActive ? color : "var(--text-tertiary)",
              background: isActive ? `color-mix(in srgb, ${color} 10%, transparent)` : "var(--bg)",
              border: `1px solid ${isActive ? color : "var(--border-light)"}`,
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: isActive ? 1 : 0.5,
            }}
          >
            <span style={{ fontSize: 12 }}>{SOURCE_ICONS[key]}</span>
            {SOURCE_LABELS[key]}
          </button>
        );
      })}
    </div>
  );
}
